

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class SmartFix extends Vue {
  @Prop()
  title: string

  @Prop()
  loading: boolean

  @Prop()
  disabled: boolean

  @Prop()
  scanned: boolean

  @Prop()
  showTable: boolean

  scan() {
    this.$emit('scan')
  }
}
